import { Icon, IconTypes, Shadow, Text, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

export declare namespace ShortcutTypes {
  interface Props {
    label: string;
    icon: IconTypes.Props['name'];
    onPress?: () => void;
  }
}

export const Shortcut: React.FC<ShortcutTypes.Props> = ({ label, icon, onPress }) => (
  <Pressable onPress={onPress} width={{ base: '48%' }}>
    <Shadow level={1} testId="shadow" borderRadius={BoxRadius.sm}>
      <VStack
        paddingRight={Spacing['inset.lg']}
        paddingLeft={Spacing['inset.nano']}
        paddingY={Spacing['inset.xs']}
        space={Spacing['stack.nano']}
        flex={1}>
        <Icon name={icon} testId="icon" size="sm" color={Color['brand.tertiary.principal']} />
        <Text fontSize={Typography['fontsize.xs']} variant="semibold" width="full">
          {label}
        </Text>
      </VStack>
    </Shadow>
  </Pressable>
);
